import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './cta-button.module.css';

interface CTAButtonProps {
    text: string;
    className?: string;  // Optional custom class name prop
}

const CTAButton: React.FC<CTAButtonProps> = ({ text, className}) => {
    return (
        <div className={styles.buttonWrapper}>
            <Button className={`${styles.cta_button} ${className}`} size="lg" href="/contact">
                {text}
            </Button>
        </div>
    );
};

export default CTAButton;